import { Component, ComponentFactoryResolver, ElementRef, Host, HostBinding, Input, OnDestroy, Optional, Renderer2, ViewContainerRef } from '@angular/core';
import { ThemeType } from '@ant-design/icons-angular';
import { BADGE, IBadge, Status } from '@app/components/elements/badge.type';
import { NzNoAnimationDirective } from 'ng-zorro-antd/core/no-animation';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

const CONTRAST_COLOR = '#ffffff';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'button[wfsBadge]',
	templateUrl: './badge-button.component.html',
	styleUrls: ['badge-button.component.scss'],
	providers: [
		{provide: BADGE, useExisting: BadgeButtonComponent},
	],
})
export class BadgeButtonComponent extends NzTooltipDirective implements IBadge, OnDestroy {
	private readonly subscription = new Subscription();
	private readonly tooltip$ = new Subject<string | null>();
	
	@Input()
	iconTheme: ThemeType = 'outline';
	@Input()
	iconName: string;
	
	@Input()
	set tooltip(text: string){
		this.tooltip$.next(text ?? null);
	}
	
	@Input()
	@HostBinding()
	disabled: boolean;
	
	/**
	 * Hintergrundfarbe der Badge, welche u.a. über die Textfarbe entscheidet
	 * @see http://www.w3.org/TR/AERT#color-contrast
	 */
	@Input()
	@HostBinding('style.background-color')
	backgroundColor = CONTRAST_COLOR;
	@Input()
	@HostBinding('style.color')
	textColor = 'black';
	
	constructor(
		translateService: TranslateService,
		elementRef: ElementRef, 
		hostView: ViewContainerRef, 
		resolver: ComponentFactoryResolver, 
		renderer: Renderer2,
		@Host() @Optional() noAnimation: NzNoAnimationDirective | null) {
		super(elementRef, hostView, resolver, renderer, noAnimation);
		
		this.subscription.add(
			this.tooltip$.pipe(
				switchMap(text => text ? translateService.get(text) : null)
			).subscribe(title=>{
				this.title = title;
			})
		);
	}
	
	public ngOnDestroy(): void {
		super.ngOnDestroy();
		this.subscription.unsubscribe();
	}
	
	public setStatus({ iconName, iconTheme, color, colorShouldBeBackground, label, disabled }: Status): void {
		this.iconName = iconName;
		this.iconTheme = iconTheme ?? 'outline';
		if (colorShouldBeBackground) {
			this.textColor = CONTRAST_COLOR;
			this.backgroundColor = color;
		} else {
			this.textColor = color;
			this.backgroundColor = CONTRAST_COLOR;
		}
		this.disabled = disabled;
		this.tooltip = label;
	}
}
